import infoCircleBlue from '../../../../../assets/icons/info-circle-blue-outline.svg';
import exclamationTriangleOrange from '../../../../../assets/icons/exclamation-triangle-orange-outline.svg';
import exclamationHexagonRed from '../../../../../assets/icons/exclamation-hexagon-red-outline.svg';
import DataUrlHelper from '../../../../helpers/data-url.helper';
import { TranslationService } from '../../../../services/translation.service';

function calculateIconUrl(severity: string): string {
  if (severity === 'severe') return DataUrlHelper.encode(exclamationHexagonRed);
  if (severity === 'normal') return DataUrlHelper.encode(exclamationTriangleOrange);
  return DataUrlHelper.encode(infoCircleBlue);
}

function TrafficSituationSeverityIcon({ severity, className }: { severity: string; className?: string }) {
  return (
    <img src={calculateIconUrl(severity)} alt={TranslationService.get(`trafficsituationspage.trafficsituation.${severity}.long`)} className={`transport-situation-severity-icon ${className ?? ''}`} />
  );
}

export default TrafficSituationSeverityIcon;
